import moment from 'moment';
import * as settlementService from '@/services/settlements-api.service';
import vuei18n from '@/plugins/vue-i18n';
import * as arcService from '@/services/arc-api.service'
import { config } from '@/plugins/env.config';
export default {
  settlements: (state) => {
    return state.settlements.map(settlement => {
      return {
        id: settlement.id,
        createdAt: moment(settlement.createdAt).format('DD/MM/YYYY'),
        sponsor: vuei18n.t(settlementService.getSponsorText(settlement.sponsorSlug)),
        amount: settlementService.sanitizeAmount(
          settlement.currencyCode,
          settlement.amount,
          false
        ),
        authorizations: settlement.authorizationCount,
        status: vuei18n.t(settlementService.getStatusText(settlement.status)),
        currencyCode: settlement.currencyCode,
        sponsorSettlementId: settlementService.getSponsorSettlementId(settlement.status, settlement.sponsorSettlementId, vuei18n),
        sponsorMedicalAccountNumber: settlementService.getSponsorMedicalAccountNumber(settlement.status, settlement.sponsorMedicalAccountNumber)
      }
    })
  },
  loadingSettlements: (state) => state.loadingSettlements,
  settlementsPage: (state) => {
    const { page } = state;
    return { ...page, number: page.number + 1 }
  },
  sponsorSelectionComplete: (state) => {
    const sponsorSlugValidator = state.createSettlement.sponsorSlug ? true : false;
    const dateFromValidator = state.createSettlement.dates.from ? true : false;
    const dateToValidator = state.createSettlement.dates.to ? true : false;
    const coveragesValidator = state.createSettlement.coverages.length > 0    
    return sponsorSlugValidator && dateFromValidator && dateToValidator && coveragesValidator
  },
  sponsorSelected: (state) => state.createSettlement.sponsorSlug,
  datesSelected: (state) => state.createSettlement.dates,
  dateFrom: (state) => state.createSettlement.dates.from ? moment(state.createSettlement.dates.from, "YYYY-MM-DD").format("DD/MM/YYYY") : "",
  dateTo: (state) => state.createSettlement.dates.to ? moment(state.createSettlement.dates.to, "YYYY-MM-DD").format("DD/MM/YYYY") : "",
  selectedSettlement: (state) => state.settlementSelected,
  getSettlementDetail: (state) => {
    return state.settlementDetail.map(detail => {
      return {
        id: detail.authorizationCode,
        claimId: detail.claimId,
        createdAt: moment(detail.createdAt).format('DD/MM/YYYY'),
        beneficiary: detail.beneficiaryName,
        memberCode: detail.beneficiaryMemberCode,
        transactionType: vuei18n.t(arcService.getType(detail)),
        branch: detail.providerBranchName,
        amount: settlementService.sanitizeAmount(
          detail.currencyCode,
          detail.amount,
          false
        ),
        sponsorTransactionId: detail.sponsorTransactionId
      }
    })
  },
  actualStep: (state) => state.createSettlement.actualStep,
  getPendingAuthorizations: (state) => {
    return state.authorizations.map(item => {
      return {
        id: item.claimId,
        createdAt: moment(item.createdAt).format('DD/MM/YYYY'),
        beneficiaryName: item.beneficiaryName,
        memberCode: item.beneficiaryMemberCode,
        coverage: vuei18n.t(arcService.getType(item)),
        sponsorTransactionId: item.sponsorTransactionId,
        uploadedRequiredFiles: item.uploadedRequiredFiles,
        totalRequiredFiles: item.totalRequiredFiles,
        satisfiesDocumentsPolicy: item.totalRequiredFiles > 0 ? item.uploadedRequiredFiles === item.totalRequiredFiles : true
      }
    })
  },
  getSettlementId: (state) => state.createSettlement.settlementId,
  getIncludedClaims: (state) => state.createSettlement.includedClaims,
  getExcludedClaims: (state) => state.createSettlement.excludedClaims,
  addAuthorizationsComplete: (state) => state.createSettlement.addAuthorizationsComplete,
  settlementCreationResult: (state) => state.createSettlement.createSettlementResult,
  createSettlementError: (state) => state.createSettlement.errorMessage,
  uploadedFiles: (state) => state.createSettlement.uploadedFiles,
  getSettlementSummary: (state) => state.settlementSummary ? state.settlementSummary.totalAmount : 0,
  getSettlementSummaryTransactionsQuantity: (state) => state.settlementSummary ? state.settlementSummary.transactionsQuantity : 0,
  getSettlementAuthorizationCoverages: (state) => state.createSettlement.coverages,
  getSettlementDocuments: (state) => state.settlementDocuments,
  manualAuthorizations: (state) => state.manualAuthorizations,
  isSponsorWithManualAuthorization: (state) => {
    const { createSettlement, settlementSelected } = state;
    const validSponsorSlug = config.validSponsorManualAuthorization;

    if (validSponsorSlug) {
      if (createSettlement) {
        const { sponsorSlug } = createSettlement;

        if( sponsorSlug ){

          if(sponsorSlug === validSponsorSlug){
            return true
          }
        }
      }
      if (settlementSelected){
        const { sponsorSlug } = settlementSelected

        if( sponsorSlug ){

          if(sponsorSlug === validSponsorSlug){
            return true
          }
        }
      }
    }
    return false;
  } 
}